module.exports = __webpack_public_path__ + "img/7250235.jpg";